import { FC } from 'react';
import Check from '../CheckIcon';

const extras = ['Text/Call', '24 hours', 'Delivers'];

interface IProps {
  type: string;
}

const VanExtras: FC<IProps> = ({ type }) => {
  return (
    <div className='van__order__extras'>
      <div className='van__order__extras__container'>
        {extras.map((el, key) => (
          <div className='van__order__extra' key={key}>
            <div className='van__order__extra__item'>
              <Check />
              <span>{el}</span>
            </div>
          </div>
        ))}
      </div>
      {type === 'passenger' && (
        <p className='van__order__extras__miles'>Unlimited Miles Specials*</p>
      )}
    </div>
  );
};
export default VanExtras;
